
import { useRecoverPasswordMutation } from "../../hooks/mutations/auth/useRecoverPasswordMutation"

import { RecoverPasswordForm } from "./RecoverPasswordForm.form"

export const RecoverPasswordFormPost = (props: RecoverPasswordFormPostProps) => {
    const {
        className,
        onSuccess,
    } = props

    const { mutateAsync: recoverPassword } = useRecoverPasswordMutation({
        onSuccess,
    })

    const handleSubmit = async (values: { email: string }) => {
        await (recoverPassword as unknown as (_values: { email: string }) => Promise<unknown>)(values)
    }

    return (
        <RecoverPasswordForm
            className={className}
            onSubmit={handleSubmit}
        />
    )
}

type RecoverPasswordFormPostProps = {
    className?: string,
    onSuccess: (_values: { email: string }) => void,
}
